import { Injectable } from '@angular/core';



//README : Use this service for maipulate the new models.WorkflowTemplateNewVM

@Injectable({ providedIn: 'root' })
export class NifValidationService {


  constructor() { }

  /// Is valid NIF
  ///  Return boolean 
  public isValidNif(nif: string|number): boolean{


    var nifAsArray: number[] = (typeof nif) === 'string' ? (<any>nif)?.split('') : nif?.toString()?.split('');
    if (nifAsArray.length != 9 && nifAsArray.length != 0)
      return false;
    const controlDigit = nifAsArray.splice(nifAsArray.length - 1, 1)[0];
    nifAsArray = nifAsArray.map((x, i) => { return Number(x) * (9 - i) });
    var checkDigit = nifAsArray.reduce((a, b) => { return a + b });
    checkDigit = (checkDigit % 11);
    checkDigit = checkDigit < 2 ? 0 : 11 - checkDigit;
    return checkDigit != controlDigit ? false : true;
  }

  public isPessoaSingularNif(nif: string | number): boolean {
    let result = false;
    if (nif === null || nif === undefined) {
      return null;
    }
    const nifString = nif?.toString();
    result = nifString.indexOf("1") == 0 ||
      nifString.indexOf("2") == 0 ||
      nifString.indexOf("3") == 0 ||
      nifString.indexOf("45") == 0; 
    return result;
  }
}
